<template>
  <div id="page-top">
    <div id="wrapper">
      <Navbar></Navbar>
      <div id="content-wrapper" class="d-flex flex-column">
        <div id="content">
          <Topbar></Topbar>
          <div class="container-fluid">
            <transition name="fade">
              <div id="preloader">
                <div data-loader="circle-side"></div>
              </div>
            </transition>
            <transition name="fade">
              <div id="loader_form">
                <div data-loader="circle-side-2"></div>
              </div>
            </transition>
            <div class="card shadow mb-4">
              <div class="card-header py-3 d-flex align-items-center justify-content-between">
                <h6 class="m-0 font-weight-bold text-dark">Activités</h6>
                <button class="btn btn-sm btn-success shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#addModalActivity" v-bind:disabled="addActivityProcess || editActivityProcess || deleteActivityProcess"><i class="fas fa-plus fa-md"></i></button>
              </div>
              <div class="card-body">
                <transition name="fade">
                  <div v-if="messageAlert" class="alert p-3" v-bind:class="{ 'alert-success': isSuccess, 'alert-danger': isError }" role="alert">
                    {{messageAlert}}
                  </div>
                </transition>
                <div class="table-responsive">
                  <table class="table table-hover table-bordered" id="dataTableActivity" width="100%" cellspacing="0">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th class="d-none">Id</th>
                        <th>Code</th>
                        <th>Nom</th>
                        <th>Nom Anglais</th>
                        <th class="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tfoot>
                      <tr>
                        <th>#</th>
                        <th class="d-none">Id</th>
                        <th>Code</th>
                        <th>Nom</th>
                        <th>Nom Anglais</th>
                        <th class="text-center">Actions</th>
                      </tr>
                    </tfoot>
                    <tbody>
                      <tr v-for="(item, index) in activities" v-bind:key="item.id">
                        <td>{{index+1}}</td>
                        <td class="d-none">{{item.id}}</td>
                        <td>{{item.code}}</td>
                        <td>{{item.name}}</td>
                        <td>{{item.name_en}}</td>
                        <td class="text-center">
                          <button class="btn btn-sm btn-primary shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#viewModalActivity" v-on:click="viewActivity(item.id)" v-bind:disabled="addActivityProcess || editActivityProcess || deleteActivityProcess">
                          <i class="fas fa-eye fa-md"></i>
                          </button>
                          <button class="btn btn-sm btn-warning shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#editModalActivity" v-on:click="viewActivity(item.id)" v-bind:disabled="addActivityProcess || editActivityProcess || deleteActivityProcess">
                          <i class="fas fa-pencil-alt fa-md"></i>
                          </button>
                          <button class="btn btn-sm btn-danger shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#deleteModalActivity" v-on:click="viewActivity(item.id)" v-bind:disabled="addActivityProcess || editActivityProcess || deleteActivityProcess">
                          <i class="fas fa-trash fa-md"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </div>
    <a class="scroll-to-top rounded" href="#page-top">
    <i class="fas fa-angle-up"></i>
    </a>
    <!-- Add Modal Activité -->
    <div class="modal fade" id="addModalActivity" tabindex="-1" role="dialog" aria-labelledby="ModalActivityLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <form id="addActivityForm" class="user" action="javascript:void(0);">
            <div class="modal-header">
              <h5 class="modal-title" id="ModalActivityLabel">Ajouter Activité</h5>
              <button class="close" type="button" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-row">
                <div class="col-sm-4">
                  <label>Code</label>
                  <input type="text" class="form-control mb-2" v-model="code1" name="code1" required>
                </div>
                <div class="col-sm-4">
                  <label>Nom</label>
                  <input type="text" class="form-control mb-2" v-model="name1" name="name1" required>
                </div>
                <div class="col-sm-4">
                  <label>Nom Anglais</label>
                  <input type="text" class="form-control mb-2" v-model="name_en1" name="name_en1" required>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-success text-uppercase w-50" href="javascript:(0)" v-on:click="addActivity" v-bind:disabled="addActivityProcess || editActivityProcess || deleteActivityProcess">
              <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="addActivityProcess">
              Ajouter
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- View Modal Activité -->
    <div class="modal fade" id="viewModalActivity" tabindex="-1" role="dialog" aria-labelledby="ModalActivityLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalActivityLabel">Activité [#<span>{{indexActivity+1}}</span>]</h5>
            <button class="close" type="button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <th scope="row">Id</th>
                  <td>{{id2}}</td>
                </tr>
                <tr>
                  <th scope="row">Code</th>
                  <td>{{code2}}</td>
                </tr>
                <tr>
                  <th scope="row">Nom</th>
                  <td>{{name2}}</td>
                </tr>
                <tr>
                  <th scope="row">Nom Anglais</th>
                  <td>{{name_en2}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary text-uppercase w-50" href="javascript:(0)" data-dismiss="modal">
            Fermer</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Edit Modal Activité -->
    <div class="modal fade" id="editModalActivity" tabindex="-1" role="dialog" aria-labelledby="ModalActivityLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <form id="editActivityForm" class="user" action="javascript:void(0);">
            <div class="modal-header">
              <h5 class="modal-title" id="ModalActivityLabel">Modifier Activité [#<span>{{indexActivity+1}}</span>]</h5>
              <button class="close" type="button" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-row">
                <div class="col-sm-4">
                  <label>Code</label>
                  <input type="text" class="form-control mb-2" v-model="code3" name="code3" required>
                </div>
                <div class="col-sm-4">
                  <label>Nom</label>
                  <input type="text" class="form-control mb-2" v-model="name3" name="name3" required>
                </div>
                <div class="col-sm-4">
                  <label>Nom Anglais</label>
                  <input type="text" class="form-control mb-2" v-model="name_en3" name="name_en3" required>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-warning text-uppercase w-50" href="javascript:(0)" v-on:click="editActivity" v-bind:disabled="addActivityProcess || editActivityProcess || deleteActivityProcess">
              <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="editActivityProcess">
              Modifier
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- delete Modal Activité -->
    <div class="modal fade" id="deleteModalActivity" tabindex="-1" role="dialog" aria-labelledby="ModalActivityLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalActivityLabel">Supprimer Activité [#<span>{{indexActivity+1}}</span>]</h5>
            <button class="close" type="button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="text-center text-uppercase mt-3">êtes-vous sûr de vouloir supprimer cette activité ?</p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-danger text-uppercase w-50" href="javascript:(0)" v-on:click="deleteActivity" v-bind:disabled="addActivityProcess || editActivityProcess || deleteActivityProcess">
            <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="deleteActivityProcess">
            Supprimer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s
}
.fade-enter,
.fade-leave-to {
  opacity: 0
}
#preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  background-color: #fff;
  z-index: 999999;
}
[data-loader="circle-side"] {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  -webkit-animation: circle infinite .95s linear;
  -moz-animation: circle infinite .95s linear;
  -o-animation: circle infinite .95s linear;
  animation: circle infinite .95s linear;
  border: 2px solid #333;
  border-top-color: rgba(0, 0, 0, 0.2);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-radius: 100%;
}
#loader_form {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 999999;
  display: none;
}
[data-loader="circle-side-2"] {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  -webkit-animation: circle infinite .95s linear;
  -moz-animation: circle infinite .95s linear;
  -o-animation: circle infinite .95s linear;
  animation: circle infinite .95s linear;
  border: 2px solid #333;
  border-top-color: rgba(0, 0, 0, 0.2);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-radius: 100%;
}
@-webkit-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>

<script>
import Navbar from './Navbar'
import Topbar from './Topbar'
import Footer from './Footer'
import axios from 'axios'
$.fn.isValid = function () {
  return this[0].checkValidity()
}
export default {
  name: 'App',
  components: {
    'Topbar': Topbar,
    'Navbar': Navbar,
    'Footer': Footer
  },
  data () {
    return {
      loading: true,
      progress: 0,
      activity: {},
      indexActivity: '',
      activities: [],
      isSuccess: true,
      isError: false,
      messageAlert: '',
      addActivityProcess: false,
      viewActivityProcess: false,
      editActivityProcess: false,
      deleteActivityProcess: false,
      code1: '',
      name1: '',
      name_en1: '',
      id2: '',
      code2: '',
      name2: '',
      name_en2: '',
      code3: '',
      name3: '',
      name_en3: '',
      dTableActivity: ''
    }
  },
  methods: {
    //Initialiser variables et tables
    init () {
      setTimeout(() => {
        this.dTableActivity = $('#dataTableActivity').DataTable({
          'columns': [
            { 'width': '15' },
            null,
            null,
            null,
            null,
            { 'width': '100' }
          ],
          'lengthMenu': [
            [10],
            [10]
          ],
          order: [
            [0, 'desc']
          ],
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true
        })
        this.activity = {
          'id': '',
          'code': '',
          'name': ''
        }
        this.code1 = ''
        this.name1 = ''
        this.name_en1 = ''
        this.id2 = ''
        this.code2 = ''
        this.name2 = ''
        this.name_en2 = ''
        this.code3 = ''
        this.name3 = ''
        this.name_en3 = ''
      }, 50)
    },
    //Sélectionner toutes les Activités (Base de données)
    getActivities () {
      axios.get(this.apiUrl+'/activities', {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          this.activities = res.data
          this.progress += 1
          if (this.progress === 1) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    //Ajouter une activité
    addActivity () {
      if ($('#addActivityForm').isValid()) {
        this.addActivityProcess = true
        let activity = {
          id: this.activities.length + 1,
          code: this.code1,
          name: this.name1,
          name_en: this.name_en1
        }
        axios.post(this.apiUrl+'/activities', activity, {headers: {'Authorization': `Bearer ${this.token}`}}).then(res => {
          if (res.status == 201) {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement ajouté avec succès'
            this.activities.push(activity)
            this.dTableActivity.destroy()
            this.init()
          }
          $('#addModalActivity').modal('hide')
          this.addActivityProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          $('#addModalActivity').modal('hide')
          this.addActivityProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        })
      }
    },
    //Sélectionner une activité (Local)
    viewActivity (id) {
      this.activity = this.activities.filter(function (item) {
        return item.id === id
      })[0]
      this.indexActivity = this.activities.indexOf(this.activity)
      this.id2 = this.activity.id
      this.code2 = this.activity.code
      this.name2 = this.activity.name
      this.name_en2 = this.activity.name_en
      this.code3 = this.activity.code
      this.name3 = this.activity.name
      this.name_en3 = this.activity.name_en
    },
    //Modifier une activité
    editActivity () {
      if ($('#editActivityForm').isValid()) {
        var id = this.activity.id
        this.editActivityProcess = true
        axios.put(this.apiUrl+'/activities/' + id, {
          code: this.code3,
          name: this.name3,
          name_en: this.name_en3
        }, {headers: {'Authorization': `Bearer ${this.token}`}}).then(res => {
          if (res.status == 200) {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement modifié avec succès'
            this.activity.code = this.code3
            this.activity.name = this.name3
            this.activity.name_en = this.name_en3
            this.activities[this.indexActivity] = this.activity
            this.dTableActivity.destroy()
            this.init()
          }
          $('#editModalActivity').modal('hide')
          this.editActivityProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          $('#editModalActivity').modal('hide')
          this.editActivityProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        })
      }
    },
    //Supprimer une activité
    deleteActivity () {
      var id = this.activity.id
      this.deleteActivityProcess = true
      axios.delete(this.apiUrl+'/activities/' + id, {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          if (res.status == 200) {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement supprimé avec succès'
            this.activities.splice(this.indexActivity, 1)
            this.dTableActivity.destroy()
            this.init()
          }
          $('#deleteModalActivity').modal('hide')
          this.deleteActivityProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          $('#deleteModalActivity').modal('hide')
          this.deleteActivityProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        })
    }
  },
  created () {
    $('body').css({'overflow': 'hidden'})
    this.getActivities()
  },
  watch: {
    loading: function () {
      this.init()
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      $('[data-loader="circle-side"]').fadeOut()
      $('#preloader').delay(350).fadeOut('slow')
      $('body').delay(350).css({
        'overflow': 'auto'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Activity.vue